import Vue from 'vue';
import Vuex from 'vuex';
import districts from '@/store/districts';
import transactions from '@/store/transactions';
import transactionsAutocompleteSearch from '@/store/transactionsAutocompleteSearch';

export default () => {
  Vue.use(Vuex);

  return new Vuex.Store({
    state: {
    },
    modules: {
      districts,
      transactions,
      transactionsAutocompleteSearch,
    },
  });
};
